// Базовые доменные перечисления. Хранятся в БД как text + CHECK, здесь — единый источник правды.

export const TASK_STATUSES = [
  'new', // ждёт принятия исполнителем
  'accepted', // принята, ещё не начата
  'in_progress',
  'blocked', // есть блокер (причина обязательна)
  'submitted', // сдана, ждёт проверки постановщиком
  'done',
  'declined', // исполнитель отказался (причина обязательна)
  'cancelled',
] as const
export type TaskStatus = (typeof TASK_STATUSES)[number]

export const OPEN_STATUSES: readonly TaskStatus[] = ['new', 'accepted', 'in_progress', 'blocked', 'submitted']
export const TERMINAL_STATUSES: readonly TaskStatus[] = ['done', 'declined', 'cancelled']

export function isOpenStatus(s: TaskStatus): boolean {
  return OPEN_STATUSES.includes(s)
}

export const STATUS_LABELS: Record<TaskStatus, string> = {
  new: 'Новая',
  accepted: 'Принята',
  in_progress: 'В работе',
  blocked: 'Есть блокер',
  submitted: 'На проверке',
  done: 'Выполнена',
  declined: 'Отклонена',
  cancelled: 'Отменена',
}

export const PRIORITIES = ['low', 'normal', 'high', 'urgent'] as const
export type Priority = (typeof PRIORITIES)[number]

export const PRIORITY_LABELS: Record<Priority, string> = {
  low: 'Низкий',
  normal: 'Обычный',
  high: 'Высокий',
  urgent: 'Срочно',
}

/** Срок — конкретное время или «к концу дня» указанной даты. */
export const DUE_KINDS = ['date', 'datetime'] as const
export type DueKind = (typeof DUE_KINDS)[number]

export const USER_STATUSES = ['invited', 'active', 'bot_blocked', 'deactivated'] as const
export type UserStatus = (typeof USER_STATUSES)[number]

export const REQUEST_KINDS = ['due_change', 'question'] as const
export type RequestKind = (typeof REQUEST_KINDS)[number]

export const REQUEST_STATUSES = ['pending', 'approved', 'rejected', 'answered', 'cancelled'] as const
export type RequestStatus = (typeof REQUEST_STATUSES)[number]

export const COMMENT_KINDS = [
  'comment',
  'return',
  'block',
  'decline',
  'question',
  'answer',
  'result',
] as const
export type CommentKind = (typeof COMMENT_KINDS)[number]

export const ORIGIN_TYPES = [
  'manual',
  'draft',
  'recurring',
  'onboarding',
  'standup',
  'one_on_one',
  'approval',
  'idea',
] as const
export type OriginType = (typeof ORIGIN_TYPES)[number]

export const NOTIFICATION_CATEGORIES = ['reminder', 'event', 'card', 'digest', 'report', 'system'] as const
export type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[number]

export const NOTIFICATION_STATUSES = ['pending', 'sending', 'sent', 'skipped', 'failed'] as const
export type NotificationStatus = (typeof NOTIFICATION_STATUSES)[number]

/** Тип календарного дня (производственный календарь РФ). */
export const DAY_KINDS = ['work', 'short', 'weekend', 'holiday'] as const
export type DayKind = (typeof DAY_KINDS)[number]

/** Отношение пользователя к задаче — основа прав. manager = руководитель исполнителя по дереву подчинения. */
export type Relation = 'creator' | 'assignee' | 'manager' | 'watcher' | 'reviewer'
